<ng-container>
  <div *ngIf="hasItems; else kpiEmpty">
    <lms-toolbar [options]="toolbarConfig">
      <div *ngIf="match.shouldDisplayObjectives" class="lms-toolbar__info position-left">
        <span *ngIf="getObjectivesDeadLineDays() > 0"
          >{{ 'kepler.kpi.durationDate' | translate : { days: getObjectivesDeadLineDays() } }}
          <b>({{ getObjectivesDeadLine({ date: match.currentObjectivesDeadline }) }})</b></span
        >
        <span *ngIf="getObjectivesDeadLineDays() === 0">{{ 'kepler.kpi.durationEndDate' | translate }}</span>
        <span
          *ngIf="getObjectivesDeadLineDays() < 0"
          [innerHtml]="
            'kepler.kpi.durationExpired'
              | translate : { date: getObjectivesDeadLine({ date: match.currentObjectivesDeadline }) }
          "
        ></span>
      </div>
      <div class="lms-toolbar__item" *lmsProfileGuard="'kepler.kpi.create'" tools-actions>
        <span class="lmstooltip">
          <gl-button
            color-primary
            title="{{
              (didMatchEnd || !match.playerCount || !didMatchStart ? null : 'kepler.addKpiGoals') | translate
            }}"
            [text]="'kepler.addKpiGoals' | translate"
            [tooltip]="
              didMatchEnd || !match.playerCount || !didMatchStart
                ? ((!didMatchStart
                    ? 'kepler.tooltipButtonNotMatchStart'
                    : didMatchEnd
                    ? 'kepler.tooltipButtonKpi'
                    : 'kepler.tooltipButtonNotPlayers'
                  ) | translate)
                : ''
            "
            [tooltipLeft]="true"
            [disabled]="didMatchEnd || !match.playerCount || !didMatchStart"
            (onClick)="openCsvModal()"
          ></gl-button>
        </span>
      </div>
    </lms-toolbar>
    <div class="gl-table__container">
      <gl-table
        [id]="clientKeplerGoalListId"
        data-testid="clientKeplerGoalListId"
        [dataSource]="dataSource"
        [placeholder]="'actions.noResultTable' | translate"
        paginator
        scroll
        (onDatasourceUpdate)="setDatasourceUpdate($event.detail.dataSource)"
      >
      </gl-table>
    </div>
  </div>
  <ng-template #kpiEmpty>
    <div class="main__void">
      <div class="main__void--icon">
        <span class="glicon-kpi"></span>
      </div>
      <span class="main__void--title">{{ 'kepler.kpisVoidTitle' | translate }}</span>
      <span class="main__void--subtitle">{{ 'kepler.kpisVoidSubtitle' | translate }}.</span>
      <span class="lmstooltip" *lmsProfileGuard="'kepler.kpi.create'">
        <gl-button
          color-primary
          title="{{ (didMatchEnd || !match.playerCount || !didMatchStart ? null : 'kepler.addKpiGoals') | translate }}"
          [text]="'kepler.addKpiGoals' | translate"
          [tooltip]="
            didMatchEnd || !match.playerCount || !didMatchStart
              ? ((!didMatchStart
                  ? 'kepler.tooltipButtonNotMatchStart'
                  : didMatchEnd
                  ? 'kepler.tooltipButtonKpi'
                  : 'kepler.tooltipButtonNotPlayers'
                ) | translate)
              : ''
          "
          [disabled]="didMatchEnd || !match.playerCount || !didMatchStart"
          (onClick)="openCsvModal()"
        ></gl-button>
      </span>
    </div>
  </ng-template>
  <lms-modal #modalCsvUpload size="medium">
    <lms-csv-import
      [isKepler]="true"
      [title]="'kepler.addKpiGoals'"
      [buttonText]="'kepler.addKpis'"
      (closeModal)="closeCsvModal()"
      (onSaveCsvData)="onSaveCsv($event)"
    >
      <div class="gl-popup__customHeadContent">
        <div>{{ 'kepler.addKpiGoalsMessage' | translate }}</div>
        <div class="inline-flex align-center margin-bottom-x-half">
          <gl-checkbox
            data-testid="rankingLastRoundGoal"
            [id]="'rankingLastRoundGoal'"
            [label]="'kepler.ranking.lastRoundGoalLabel' | translate"
            [checked]="enabledLastRoundGoal"
            [attr.small]="true"
            (onChange)="lastRoundGoal($event)"
          >
          </gl-checkbox>
          <gl-tooltip class="margin-left-8" posTop [text]="tooltipTextLastRound"></gl-tooltip>
        </div>
        <div>
          1. <a (click)="downloadCsv()">{{ 'kepler.csv.step1' | translate }}</a>
        </div>
        <div>2. {{ 'kepler.csv.step2-1' | translate }}</div>
        <div>3. {{ 'kepler.csv.step3' | translate }}</div>
      </div>
    </lms-csv-import>
  </lms-modal>
  <lms-modal #confirmKpiModal [size]="enabledLastRoundGoal || !match.shouldDisplayObjectives ? 'medium' : 'x-small'">
    <div class="gl-popup__title">
      {{
        enabledLastRoundGoal || !match.shouldDisplayObjectives
          ? ('kepler.kpiConfirmTitle' | translate)
          : ('kepler.kpiConfirmTitleLimit' | translate)
      }}
    </div>
    <div class="gl-popup__close" (click)="closeConfirmKpiModal()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__text">
      {{ 'kepler.kpiConfirmMessage' | translate }}
    </div>
    <div *ngIf="enabledLastRoundGoal" class="gl-popup__text">{{ tooltipTextLastRound }}</div>
    <div *ngIf="!enabledLastRoundGoal && match.shouldDisplayObjectives" class="margin-top-24">
      <lms-dynamic-form
        [questions]="limitQuestions"
        [options]="{ disableCard: true, submitLabel: 'actions.confirm', isDirtySubmit: true }"
        (submit)="confirmModal()"
      >
        <gl-button
          color-secondary
          [text]="'actions.cancel' | translate"
          (onClick)="closeConfirmKpiModal()"
          form-actions-before
        ></gl-button>
      </lms-dynamic-form>
    </div>
    <div *ngIf="enabledLastRoundGoal || !match.shouldDisplayObjectives" class="gl-popup__buttons">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="closeConfirmKpiModal()"></gl-button>
      <gl-button color-primary [text]="'actions.confirm' | translate" (onClick)="confirmModal()"> </gl-button>
    </div>
  </lms-modal>
</ng-container>
